import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchData, postData, putData, deleteData } from '../../../services/Api';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';

const ConjuntoItemContext = createContext();

export const useConjuntoItem = () => useContext(ConjuntoItemContext);

export const ConjuntoItemProvider = ({ children }) => {
    const [conjuntoItens, setConjuntoItens] = useState([]);    
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchConjuntoItens = useCallback(async (conjuntoId) => {
        if (!conjuntoId) {
            setConjuntoItens([]);
            return;
        }

        try {
            const result = await fetchData(`/ConjuntoItem?conjuntoId=${conjuntoId}`);
            setConjuntoItens(result);
        } catch (error) {
            console.error("Erro ao buscar itens do conjunto:", error);
            showMessage(`Erro ao buscar itens do conjunto! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    useEffect(() => {
        fetchConjuntoItens();
    }, [fetchConjuntoItens]);

    const addConjuntoItem = async (item) => {
        try {
            const result = await postData('/ConjuntoItem', item);
            setConjuntoItens([...conjuntoItens, result]);
            showAlert('Item do conjunto adicionado com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar item do conjunto:", error);
            showMessage('Erro ao adicionar item do conjunto!\n' + error, 'danger');
        }
    };

    const updateConjuntoItem = async (item) => {
        try {
            const result = await putData('/ConjuntoItem', item);
            setConjuntoItens((prev) =>
                prev.map((i) => (i.id === result.id ? result : i))
            );
            showAlert('Item do conjunto alterado com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar item do conjunto:", error);
            showAlert('Erro ao alterar item do conjunto!', 'danger');
        }
    };

    const deleteConjuntoItem = async (id) => {
        try {
            await deleteData('/ConjuntoItem', { id });
            setConjuntoItens(conjuntoItens.filter(i => i.id !== id));
            showAlert('Item do conjunto inativado com sucesso!');
        } catch (error) {
            console.error("Erro ao inativar item do conjunto:", error);
            showAlert('Erro ao inativar item do conjunto!', 'danger');
        }
    };

    return (
        <ConjuntoItemContext.Provider value={{
            conjuntoItens,
            addConjuntoItem,
            updateConjuntoItem,
            deleteConjuntoItem,
            fetchConjuntoItens
        }}>
            {children}
        </ConjuntoItemContext.Provider>
    );
};
